import {theme, Typography} from 'antd';
import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const {token}: any = theme.useToken();

  return (
    <div
      style={{
        backgroundColor: token.colorBgContainer,
        borderTop: `1px solid ${token.colorBorder}`,
        display: 'flex',
        height: 50,
        justifyContent: 'center',
        alignItems: 'center',
      }}>
      <Typography.Text data-testid="footer-text" style={{color: token.colorTextSecondary}}>
        &copy; {currentYear} by Capillary Technologies.
      </Typography.Text>
    </div>
  );
};

export default Footer;
